// TopNav owns the search palette and the auth modal. Other parts of the page
// (e.g. homepage CTAs) open them through these window events instead of
// mounting their own copies.
export const STOREFRONT_EVENTS = {
  openSearch: 'tp:open-search',
  openAuth: 'tp:open-auth',
};

export const openSearch = () => {
  window.dispatchEvent(new CustomEvent(STOREFRONT_EVENTS.openSearch));
};

export const openAuth = (mode = 'login') => {
  window.dispatchEvent(new CustomEvent(STOREFRONT_EVENTS.openAuth, { detail: { mode } }));
};
